
  document.addEventListener('DOMContentLoaded', function () {
    class WJAnimationCard extends HTMLElement {
      constructor() {
        super();
        this.swiperList = null;
        this.activeIndex = 0;
        this.slider = null;

        this.navProgressRaf = null;
        this.autoplayEnabled = true;
        // 后台填写秒，代码统一换算成毫秒
        this.autoplayDelay = 3000;
      }

      connectedCallback() {
        this.initSwiper();
        this.initScrollAnimation();
      }

      disconnectedCallback() {
        if (this.swiperList) {
          this.swiperList.destroy(true, true);
        }
      }

      initSwiper() {
        const listEl = this.querySelector('.wj-animation-card-list.swiper');
        if (!listEl) return;

        // Check if already initialized
        if (listEl.swiper) {
          this.swiperList = listEl.swiper;
          return;
        }

        // Initialize Main List Swiper
        this.swiperList = new Swiper(listEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          centeredSlides: false,
          speed: 500,
          autoHeight: true,
          grabCursor: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          
          pagination: {
            el: this.querySelector('.wj-animation-card-pagination'),
            clickable: true,
          },
          on: {
            init: (e) => {
              setTimeout(() => {
                e.emit('slideChangeTransitionEnd')
              }, 1000)
            },
            slideChangeTransitionEnd: (e) => {
              const containers = this.querySelectorAll('.yg-video-container');
              const currentContainer = containers[e.realIndex ?? e.activeIndex];

              containers.forEach((container) => {
                const video = container.querySelector('yg-video');
                if (video && typeof video.pauseVideo === 'function') {
                  container.classList.remove('active')
                  video.pauseVideo();
                }
              })

              if (currentContainer) {
                const video = currentContainer.querySelector('yg-video');
                if (video && typeof video.playVideo === 'function') {
                  currentContainer.classList.add('active')
                  video.playVideo();
                }
              }
            },
          },
        });

        // Listen for external color switch events (from other sections)
        document.addEventListener('wj-color-switch', (e) => {
          if (e.detail && typeof e.detail.index === 'number' && e.detail.source !== 'wj-animation-card') {
            if (this.swiperList) {
              this.swiperList.slideTo(e.detail.index);
            }
          }
        });

        // Update active state on slide change
        this.swiperList.on('slideChange', () => {
          this.updateActiveState();
        });

        // Initialize active state
        this.updateActiveState();

      }

      updateActiveState() {
        if (!this.swiperList) return;

        const realIndex = this.swiperList.realIndex || this.swiperList.activeIndex;
        this.activeIndex = realIndex;

        // Dispatch global event for other synced sections
        document.dispatchEvent(new CustomEvent('wj-color-switch', {
          detail: { index: realIndex, source: 'wj-animation-card' }
        }));
        // 更新 heading (title) 激活状态
        const headings = this.querySelectorAll('.wj-animation-card-heading');
        headings.forEach((heading, index) => {
          if (index === realIndex) {
            heading.classList.add('active');
          } else {
            heading.classList.remove('active');
          }
        });

        // 更新 content 激活状态
        const contents = this.querySelectorAll('.wj-animation-card-content');
        contents.forEach((content, index) => {
          if (index === realIndex) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });

      }

      // 当整个模块滚动进入视口时，让内部图片从底部滑入回到原位
      initScrollAnimation() {
        if (!('IntersectionObserver' in window)) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {

              const slots = this.querySelectorAll('.wj-animation-card-media-slot');

              if (entry.isIntersecting) {
                // 进入视口 → 播放动画
                slots.forEach((slot, i) => {
                  setTimeout(() => {
                    slot.classList.add('wj-slot-in-view');
                  }, i * 120);
                });
              } else {
                // 离开视口 → 重置动画状态
                slots.forEach((slot) => {
                  slot.classList.remove('wj-slot-in-view');
                });
              }

            });
          },
          {
            threshold: 0.3,
          }
        );

        observer.observe(this);
      }
    }

    if (!customElements.get('wj-animation-card')) {
      customElements.define('wj-animation-card', WJAnimationCard);
    }
  });

